import { Template100 } from './templates/Template100'
import { Template1005050 } from './templates/Template1005050'
import { Template5050 } from './templates/Template5050'
import { Template5050100 } from './templates/Template5050100'
import { TemplateColumnist } from './templates/TemplateColumnist'
import { TemplateSideBox } from './templates/TemplateSideBox'
import { TemplateSideBoxGeneric } from './templates/TemplateSideBoxGeneric'
import { TemplateSideBoxFixed } from './templates/TemplateSideBoxFixed'
import { TemplateSideBoxPodcast } from './templates/TemplateSideBoxPodcast'
import { TemplateSideBoxRadio } from './templates/TemplateSideBoxRadio'
import { TemplateSideBoxStories } from './templates/TemplateSideBoxStories'
import { TemplateSideBoxColumnist } from './templates/TemplateSideBoxColumnist'
import { TemplateSideBoxNoTitle } from './templates/TemplateSideBoxNoTitle'
import { TemplateSidebarLeft } from './templates/TemplateSidebarLeft'
import { TemplateSuperManchete } from './templates/TemplateSuperManchete'
import { TemplateVideoLive } from './templates/TemplateVideosLive'
import { TemplateVideos } from './templates/TemplateVideos'

const templates = {
  Template100,
  Template1005050,
  Template5050,
  Template5050100,
  TemplateColumnist,
  TemplateSidebarLeft,
  TemplateSideBox,
  TemplateSideBoxGeneric,
  TemplateSideBoxFixed,
  TemplateSideBoxPodcast,
  TemplateSideBoxRadio,
  TemplateSideBoxStories,
  TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle,
  TemplateSuperManchete,
  TemplateVideoLive,
  TemplateVideos
}

export const templatesArray: string[] = Object.keys(templates)

export type templatesTypes = typeof templatesArray[number]

export { templates }

